import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { GLOBAL } from './global';

export interface BulkLocationJob {
  key: string;
  status: 'queued' | 'processing' | 'done' | 'error';
  totalItems: number;
  processedItems: number;
  errosMsg?: string[];
  msg?: string;
}

@Injectable({
  providedIn: 'root'
})
export class TicketsService {
  private url: string;
  private url2: string;
  private token: string | null;
  private headers: HttpHeaders;

  constructor(private _router: Router, private _http: HttpClient, private clientFireDatabase: AngularFireDatabase) {
    this.url = `${GLOBAL.url}/ticket/`;
    this.url2 = `${GLOBAL.url}/ticketindex/`;
 
    this.token = JSON.parse(localStorage.getItem('token'));
    //this.token = this.token === 'undefined' ? null : this.token;
    this.headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
  }

  create(json: any): Observable<any> {
    return this.petition(this.url + 'new', json);
  }

  getOne(id: any): Observable<any> {
    return this.petition(`${this.url}detail/${id}`);
  }

  checkItems(json: any): Observable<any> {
    return this.petition(`${this.url}preticket`, json);
  }

  indexesdetail(id: any): Observable<any> {
    return this.petition(`${this.url}indexesdetail/${id}`);
  }

  indexesmanifestdetail(id: any): Observable<any> {
    return this.petition(`${this.url}indexesmanifestdetail/${id}`);
  }

  indexesscrap(id: any): Observable<any> {
    return this.petition(`${this.url}indexesscrapdetail/${id}`);
  }

  bulkstatus(json: any): Observable<any> {
    return this.petition(`${this.url2}bulkstatus`, json);
  }

  procesarBulk(json: any): Observable<any> {
    return this.petition(`${GLOBAL.url}/weightitem/processbulk`, json);
  }

  procesarycrearBulk(json: any): Observable<any> {
    return this.petition(`${GLOBAL.url}/weightitem/processandcreatebulk`, json);
  }

  processDeliveredTicketContainers(
    ticketIds: number[]
  ): Observable<any> {

    const json = {
      tickets: ticketIds
    };

    return this.petition(
      `${this.url}processdeliveredcontainers`,
      json
    );
  }

  bulkReceived(json: any): Observable<any> {
    return this.petition(`${this.url2}bulkreceive`, json);
  }

  bulkLocations(json: any): Observable<any> {
    return this.petition(`${GLOBAL.url}/weightitem/changebulklocation`, json);
  }

  /**
   * Watches a background job's live progress/result in Firebase RTDB at
   * {collection}/{jobId}. Used by any endpoint that enqueues instead of
   * processing inline (changebulklocation, savebulkchanges, ...) — pass the
   * collection name matching whatever the backend's FirebaseService wrote to
   * (default matches the original bulk-location-change feature).
   */
  watchBulkLocationJob(jobId: string, collection: string = 'weightItemBulkLocationJobs'): Observable<BulkLocationJob> {
    return this.clientFireDatabase.object(`${collection}/${jobId}`).snapshotChanges().pipe(
      map(change => ({ key: change.payload.key, ...(change.payload.val() as any) }))
    );
  }

  getPOs(): Observable<any> {
    return this.petition(`${GLOBAL.url}/po/listwithpi`);
  }

  getPOsNotInvoiced(): Observable<any> {
    return this.petition(`${GLOBAL.url}/po/notinvoiced`);
  }

  removeItemContainer(id: any, json: any): Observable<any> {
    return this.petition(`${GLOBAL.url}/weightitem/removeitemcontainer/${id}`, json);
  }

  removeBulkItemContainer(id: any, json: any): Observable<any> {
    return this.petition(`${GLOBAL.url}/weightitem/removebulkitemcontainer/${id}`, json);
  }

  dropContainer(id: any): Observable<any> {
    return this.petition(`${GLOBAL.url}/weightitem/dropcontainer/${id}`);
  }

  changeContainer(json: any): Observable<any> {
    return this.petition(`${GLOBAL.url}/weightitem/changecontainer`, json);
  }

  removeItemBatch(id: any, json: any): Observable<any> {
    return this.petition(`${GLOBAL.url}/weightitem/removeitembatch/${id}`, json);
  }

  removeBulkItemBatch(id: any, json: any): Observable<any> {
    return this.petition(`${GLOBAL.url}/weightitem/removebulkitembatch/${id}`, json);
  }

  dropBatch(id: any): Observable<any> {
    return this.petition(`${GLOBAL.url}/weightitem/dropbatch/${id}`);
  }


  getAll(type: any = 'ALL', page: any, perPage: any, search: any, sort: any = '', sortby: any = ''): Observable<any> {
    let url = `${this.url}listbyall/${type}?page=${page}&perpage=${perPage}`;
    
    if (sortby !== '') {
      if (sort === '') {
        sort = 'DESC';
      }
      url += `&order=${sort}&orderby=${sortby}`;
    }

    return this.petition(url, search);
  }

  edit(id: any, json: any): Observable<any> {
    return this.petition(`${this.url}edit/${id}`, json);
  }

  editWeight(json: any): Observable<any> {
    return this.petition(`${GLOBAL.url}/weightitem/editweight`, json);
  }

  editComments(id: any, json: any): Observable<any> {
    return this.petition(`${this.url2}editcomment/${id}`, json);
  }

  delete(id: any): Observable<any> {
    return this.petition(`${this.url}remove/${id}`);
  }

  getSearch(page: any, perPage: any, search: any): Observable<any> {
    return this.petition(`${this.url}search?page=${page}&perpage=${perPage}`, search);
  }

  getByPO(po_id: any): Observable<any> {
    return this.petition(`${this.url}listbypo/${po_id}`);
  }

  createWeight(json: any, bulk_cant: any = 0): Observable<any> {
    if (bulk_cant > 1) {
      json.bulk_cant = bulk_cant;
      return this.petition(`${GLOBAL.url}/weightitem/newbulk`, json);
    }
    return this.petition(`${GLOBAL.url}/weightitem/new`, json);
  }

  createVirtual(json: any): Observable<any> {
    return this.petition(`${GLOBAL.url}/weightitem/newvirtual`, json);
  }

  editVirtual(id: any, json: any): Observable<any> {
    return this.petition(`${GLOBAL.url}/weightitem/editvirtual/${id}`, json);
  }

  getAllNew(
    status: string = 'PENDING',
    warehouse: string = 'ALL',
    page: number = 1,
    perPage: number | string = 10,
    filters: any[] = [],
    sort: string = '',
    sortBy: string = ''
  ): Observable<any> {
    const url = `${this.url}listbyallnewtable/${status}`;

    let params = new HttpParams()
      .set('page', String(page))
      .set('perpage', String(perPage))
      .set('warehouse', warehouse);

    if (sortBy !== '') {
      params = params
        .set('order', sort === 'ASC' ? 'ASC' : 'DESC')
        .set('orderby', sortBy);
    }

    filters.forEach((filter: any) => {
      const key = filter?.key;
      const keyType = filter?.key_type;
      const type = filter?.type;

      let value = String(filter?.value ?? '')
        .trim()
        .replace(/[´`'"]/g, '');

      /*
       * Como ID debe contener números, hacemos una
       * limpieza adicional únicamente para ese filtro.
       */
      if (key === 'id') {
        value = value.replace(/\D/g, '');
      }

      if (
        key &&
        value !== '' &&
        type !== 'nofilter'
      ) {
        params = params.set(key, value);

        if (keyType && type) {
          params = params.set(keyType, type);
        }
      }
    });

    return this.petition(
      `${url}?${params.toString()}`,
      {}
    );
  }

  resolveTicketItem(
    ticketId: number | string,
    itemId: number | string
  ): Observable<any> {
    const url =
      `${this.url}resolveticketitem/` +
      `${ticketId}/${encodeURIComponent(String(itemId))}`;

    return this.petition(url, {});
  }


  petition(url: any, json: any = null, type: any | null = null): Observable<any> {

    this.token = JSON.parse(localStorage.getItem('token'));
  

    let params = `authorization=${this.token}`;

    if (json !== null) {
      const jsonStr = encodeURIComponent(JSON.stringify(json));
      params += `&json=${jsonStr}`;
    }

    if (type !== null) {
      params += `&type=${type}`;
    }

   

    return this._http.post(url, params, { headers: this.headers }).pipe(
      map((res: any) => res)
    );
  }
}
